<template>
  <div class="app-body">
    <div class="activity-bg" :style="bgStyle">
      <div class="activity-toolbar">
        <van-button type="info" block to="/activity/signup">立即报名</van-button>
        <van-button type="info" block to="/about">关于我们</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  data() {
    return {
      data: {}
    }
  },
  computed: {
    bgStyle() {
      let img = this.data.activitybg ? (rootPath + this.data.activitybg) : (this.assetsPath + 'static/images/activity-bg.jpg');
      return {'background-image':`url(${img})`};
    }
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.activity {
  &-bg {
    position:relative;
    height:100vh;
    background-size:cover;
    background-repeat:no-repeat;
  }
  &-toolbar {
    position:absolute;
    left:0;
    bottom:0;
    right:0;
    padding:1rem;
    .bg-white(.85);
    .van-button {
      margin-top:1rem;
      .fontsize(1.1rem);
      &:first-child {
        margin-top:0;
      }
    }
  }
}
</style>